export default "__VITE_ASSET__Dc2y5E57__"